import React from "react"
import { observer } from "mobx-react"
import { useTranslations } from "next-intl"

import InputTitle from "~/components/parking/Landing/Forms/Elements/InputTitle"
import Spacer from "~/components/Spacer"
import useInject from "~/hooks/useInject"
import State from "~/components/parking/Landing/Forms/Dropdown/State"

const mapStore = (store) => ({
  licenseState: store.trafficLookup.licenseState,
  setLicenseState: store.trafficLookup.setLicenseState,
})

const LicenseState = ({ compact = false }) => {
  const { licenseState, setLicenseState } = useInject(mapStore)
  const translate = useTranslations("form.traffic.licenseState")

  return (
    <>
      <InputTitle>
        {translate("label")}
        {!compact && <Spacer direction="width" mobile={11} desktop={11} />}
      </InputTitle>
      {!compact && <Spacer desktop={16} mobile={4} />}
      <State
        autoFocus={false}
        noIcon
        blurInputOnSelect
        maxMenuHeight={140}
        selectedState={licenseState.shortName}
        onChange={setLicenseState}
      />
    </>
  )
}

export default observer(LicenseState)
